/**
 * @generated SignedSource<<7f8030f6e8af347b557e764347190787>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RepositoryLabelsInternal$data = {
  readonly " $fragmentSpreads": FragmentRefs<"LabelList">;
  readonly " $fragmentType": "RepositoryLabelsInternal";
};
export type RepositoryLabelsInternal$key = {
  readonly " $data"?: RepositoryLabelsInternal$data;
  readonly " $fragmentSpreads": FragmentRefs<"RepositoryLabelsInternal">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RepositoryLabelsInternal",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 50
        }
      ],
      "kind": "FragmentSpread",
      "name": "LabelList"
    }
  ],
  "type": "Repository",
  "abstractKey": null
};

(node as any).hash = "80c7ce166310749f6a3b0edb295b75c9";

export default node;
